import { render, staticRenderFns } from "./BienDetailsDescription.vue?vue&type=template&id=7e6b7e4a"
import script from "./BienDetailsDescription.vue?vue&type=script&lang=js"
export * from "./BienDetailsDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports